'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _reactI18next = require('react-i18next');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var mapStyles = {
  Map: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: function minHeight(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '15rem' : 'none';
    },
    '& img': {
      maxHeight: '300px',
      display: 'block',
      objectFit: 'cover',
      width: '100%',
      height: function height(_ref2) {
        var responsiveMode = _ref2.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '15rem' : 'auto';
      }
    }
  }
};
var MapContainer = function (_Component) {
  _inherits(MapContainer, _Component);
  function MapContainer() {
    _classCallCheck(this, MapContainer);
    return _possibleConstructorReturn(this, (MapContainer.__proto__ || Object.getPrototypeOf(MapContainer)).apply(this, arguments));
  }
  _createClass(MapContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        pagination = _props.pagination,
        t = _props.t;
      var isFetching = pagination.isFetching;
      var _Object$keys$map$ = Object.keys(entities.events).map(function (k) {
          return entities.events[k];
        })[0],
        staticMap = _Object$keys$map$.staticMap,
        coordinates = _Object$keys$map$.coordinates;
      return _react2.default.createElement('div', {
        className: classes.Map
      }, !!isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        size: 50
      }) : !!staticMap && !!coordinates.lat && !!coordinates.lng ? _react2.default.createElement('a', {
        href: 'https://www.google.com/maps/search/?api=1&query=' + coordinates.lat + ',' + coordinates.lng,
        target: '_blank'
      }, _react2.default.createElement('img', {
        alt: 'map',
        src: staticMap
      })) : _react2.default.createElement('p', null, t('map.not_location')));
    }
  }]);
  return MapContainer;
}(_react.Component);
exports.default = (0, _reactJss2.default)(mapStyles)((0, _reactI18next.translate)('Misc')(MapContainer));